export default __webpack_public_path__ + "ae1458f53dfdaeadb2a87f522ea64ffe.svg";